// src/app/core/services/device.service.ts
import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject, fromEvent } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DeviceService {
  private isMobileSubject = new BehaviorSubject<boolean>(window.innerWidth <= 768);
  isMobile$ = this.isMobileSubject.asObservable();

  constructor(private ngZone: NgZone) {
    this.ngZone.runOutsideAngular(() => {
      fromEvent(window, 'resize').subscribe(() => {
        const isMobile = window.innerWidth <= 768;
        this.ngZone.run(() => this.isMobileSubject.next(isMobile));
      });
    });
  }

  get isMobile(): boolean {
    return this.isMobileSubject.getValue();
  }
}
